/**
 * Mapeo de `rejected_reason` (label que actualmente envía el portal) hacia su
 * `generic_rejected_reason`. La llave es el label de rechazo y el valor es el
 * motivo genérico que debe enviarse al orquestador de pricing.
 *
 * A partir del `rejected_reason` se obtiene el `generic_rejected_reason`
 * mediante `getGenericRejectedReason`.
 *
 * Fuente: CSV "Razón rechazo comité - Hoja 2". Para el primer bloque de
 * motivos el `generic_rejected_reason` es un código numérico ("1".."34");
 * para el resto coincide con el texto del motivo.
 */
export const GENERIC_REJECTED_REASON_MAP: Record<string, string> = {
  // label -> generic_rejected_reason (código numérico)
  'Ultimo piso sin ascensor.': '1',
  'Inmueble en zona de riesgo': '2',
  'Inmueble PH < 10 unidades': '3',
  'Problemas estructurales en el conjunto.': '4',
  'Inmueble fuera de zonas habi.': '5',
  'Problemas de humedad demasiado graves para poder ser arreglados.': '6',
  'Muy poca confianza en pricing.': '7',
  'Tipología muy poco común en el sector.': '8',
  'Porcentaje en venta mayor al 10%.': '9',
  'Valor de compra Habi inferior a 75 MM.': '10',
  'Rechazo por falta de cupos en zona': '11',
  'Ask price superior a tope habi en zona.': '12',
  'Falta doc de área construida.': '13',
  'Falta doc de garaje.': '14',
  'Falta doc de área construida y garaje.': '15',
  'Inmueble no habi.': '16',
  'Valor admon muy elevado.': '17',
  'Rechazado por recomendación del avaluador.': '18',
  'Rechazado por Black list.': '19',
  'Validar % en venta.': '20',
  'Recomendación del avaluador.': '21',
  'Faltan docs legales.': '22',
  'Por antigüedad.': '23',
  'Falta informacion de visita operativa': '24',
  'Falta recibo admon': '25',
  'Rechazo por recomendación del aprobólogo': '26',
  'Rechazo por comité remodelaciones': '27',
  Duplicado: '28',
  'Rechazo por ampliaciones ilegales': '29',
  'Rechazo solución cliente': '30',
  'Rechazo por área de construcción': '31',
  'Pre aprobado': '32',
  'Rechazo por acta de administración': '33',
  'Error en Retool o BD': '34',

  // label -> generic_rejected_reason (texto)
  'Inmueble mayor a unidad rentable': 'Inmueble mayor a unidad rentable',
  'Inmueble con distribución no funcional':
    'Inmueble con distribución no funcional',
  'Espacios sin ventilación natural': 'Espacios sin ventilación natural',
  Vecindad: 'Vecindad',
  'Fusión ilegal del inmueble': 'Fusión ilegal del inmueble',
  'Inmueble con uso  no habitacional': 'Inmueble con uso  no habitacional',
  'Inmueble con varillas expuestas': 'Inmueble con varillas expuestas',
  'Espacio habitable con techo de lámina':
    'Espacio habitable con techo de lámina',
  'Revenue demasiado bajo': 'Revenue demasiado bajo',
  Vista: 'vista interna inmueble caro"',
  'Inmueble demasiado caro sin ascensor':
    'Inmueble demasiado caro sin ascensor',
  'Estrato 1 Cali': 'estrato_1_cali',
  'Rechazo temporal pricing': 'Rechazo temporal pricing',
  'Rechazo temporal aprobación': 'Rechazo temporal aprobación',
  'Rechazo por tiempos de venta esperados':
    'Rechazo por tiempos de venta esperados',
  'Rechazo por tipologia de bajo performance':
    'Rechazo por tipologia de bajo performance',
  'Rechazo por calidad de la zona': 'Rechazo por calidad de la zona',
  'Rechazo por servicios públicos': 'Rechazo por servicios públicos',
  'Rechazo por seguridad': 'Rechazo por seguridad',
  'Rechazo por acceso a la propiedad': 'Rechazo por acceso a la propiedad',
  'Ticket alto sin ascensor': 'Ticket alto sin ascensor',
  'Ticket alto sin garaje': 'Ticket alto sin garaje',
  'Recomendación de IM': 'Recomendación de IM',
  'Rechazo por Gravamen': 'Rechazo por Gravamen',
  'Rechazo por topes de zonas': 'Rechazo por topes de zonas',
  'Rechazo por topes (limon)': 'Rechazo por topes (limon)',
  'Rechazo por ticket alto': 'Rechazo por ticket alto',
  'Rechazo por 3 recibos': 'Rechazo por 3 recibos',
  'inmueble sin cerramiento ni vigilancia privada':
    'inmueble sin cerramiento ni vigilancia privada',
  'Normativa Infonavit / Fovissste': 'Normativa Infonavit / Fovissste',
  'Segunda Visita': 'Segunda Visita',
  'Prediccion modelo area no coincide': 'Prediccion modelo area no coincide',
  'Rechazado por calificación de Remo': 'Rechazado por calificación de Remo',
  'Tiene patrimonio de familia y falta declaración sobre hijos menores':
    'Tiene patrimonio de familia y falta declaración sobre hijos menores',
  'Inmueble tiene sellos de clausurado': 'Inmueble tiene sellos de clausurado',
  'Vista - Mala Experiencia': 'Vista - Mala Experiencia',
  'Visita vencida': 'Visita vencida',
  'Rechazo temporal -> Remo': 'Rechazo temporal -> Remo',
  'Rechazo por margen bruto esperado': 'Rechazo por margen bruto esperado',
  'Rechazo Leasing Banco Caja Social': 'Rechazo Leasing Banco Caja Social',
  'Inmueble mayor a 30 años VIS': 'Inmueble mayor a 30 años VIS',
  'Nid sin lote_id': 'Nid sin lote_id',
  'No disponible para pricing por estado':'No disponible para pricing por estado',
  'Inconsistencia en coordenadas': 'Inconsistencia en coordenadas',
  'Inmueble con area menor a 38 mts': 'Inmueble con area menor a 38 mts',
  'Rechazo temporal - Duplicados en muestra':
    'Rechazo temporal - Duplicados en muestra',
  'Rechazo temporal - Áreas accesorias': 'Rechazo temporal - Áreas accesorias',
  'Rechazo temporal - Mezcla de tipologías':
    'Rechazo temporal - Mezcla de tipologías',
  'Rechazo temporal - Revisiones de negocio con IM':
    'Rechazo temporal - Revisiones de negocio con IM',
  'Rechazo temporal - Validaciones con el área de remodelaciones':
    'Rechazo temporal - Validaciones con el área de remodelaciones',
  'Rechazo temporal - Error de datos en revisión de documentos':
    'Rechazo temporal - Error de datos en revisión de documentos',
  'Rechazo temporal - Ajuste por vista': 'Rechazo temporal - Ajuste por vista',
  'Rechazo temporal - Ajuste por antigüedad':
    'Rechazo temporal - Ajuste por antigüedad',
  'Rechazo temporal - Ajuste por tope de ciudad':
    'Rechazo temporal - Ajuste por tope de ciudad',
  'Rechazo temporal - Ajuste por vigencia de precio':
    'Rechazo temporal - Ajuste por vigencia de precio',
  'Rechazo temporal - Comparable cliente dentro de la muestra':
    'Rechazo temporal - Comparable cliente dentro de la muestra',
  'Rechazo temporal - Duplicados': 'Rechazo temporal - Duplicados',
  'Rechazo temporal - Coeficiente alto': 'Rechazo temporal - Coeficiente alto',
  'Rechazo temporal - Comparables incorrectos':
    'Rechazo temporal - Comparables incorrectos',
  'Rechazo temporal - Error en herramienta':
    'Rechazo temporal - Error en herramienta',
  'Rechazo temporal - Validación con remo':
    'Rechazo temporal - Validación con remo',
  'Rechazo temporal - Precio vencido': 'Rechazo temporal - Precio vencido',
  'Rechazo temporal - Error en Área': 'Rechazo temporal - Error en Área',
  'Rechazo temporal - Error en antigüedad':
    'Rechazo temporal - Error en antigüedad',
  'Rechazo temporal - Error en baños': 'Rechazo temporal - Error en baños',
  'Rechazo temporal - Error en garaje': 'Rechazo temporal - Error en garaje',
  'Rechazo temporal - Error en georreferenciación':
    'Rechazo temporal - Error en georreferenciación',
};

const normalize = (value: string): string => value.trim().toLowerCase();

const NORMALIZED_GENERIC_REJECTED_REASON_MAP: Record<string, string> =
  Object.entries(GENERIC_REJECTED_REASON_MAP).reduce(
    (acc, [label, generic]) => {
      acc[normalize(label)] = generic;
      return acc;
    },
    {} as Record<string, string>
  );

/**
 * Obtiene el `generic_rejected_reason` a partir del `rejected_reason` (label).
 * Devuelve `undefined` si el label no tiene un mapeo definido.
 */
export const getGenericRejectedReason = (
  rejectedReason?: string
): string | undefined => {
  if (!rejectedReason) {
    return undefined;
  }

  return NORMALIZED_GENERIC_REJECTED_REASON_MAP[normalize(rejectedReason)];
};
